export { default as MaterialsBrandsFilter } from './MaterialsBrandsFilter';
